module.exports = __webpack_public_path__ + "static/media/CabinSketch-Bold.25d4e30a.eot";